// apps/cli/src/commands/enterprise/campaigns/view.ts
import type { Command } from 'commander';
import { unwrapDataResponse } from '@wport/core';
import { enterpriseGet } from '../../../lib/enterprise-client';
import { resolveApiKey } from '../../../lib/credentials-store';
import { resolveContext } from '../../../lib/global-opts';
import { CliError, ExitCode } from '../../../lib/errors';
import { printJson } from '../../../lib/output';
import { parseFieldsList, pickPaths } from '../../../lib/path-utils';

interface ViewFlags {
	fields?: string;
}

/** campaign 詳情含職缺清單（巢狀）→ 一律 JSON（不做表格）。 */
export async function runEnterpriseCampaignsView(
	ctx: { baseUrl: string; locale: string; timeoutMs: number },
	apiKey: string,
	encId: string,
	flags: ViewFlags
): Promise<void> {
	const trimmed = encId.trim();
	if (!trimmed) {
		throw new CliError('enc_id must not be empty', ExitCode.InvalidArgument);
	}
	const { body } = await enterpriseGet(
		{ baseUrl: ctx.baseUrl, locale: ctx.locale, timeoutMs: ctx.timeoutMs, apiKey },
		`/campaigns/${encodeURIComponent(trimmed)}`
	);
	const campaign = unwrapDataResponse<Record<string, unknown>>(body);
	if (flags.fields) {
		printJson(pickPaths(campaign, parseFieldsList(flags.fields)));
		return;
	}
	printJson(campaign);
}

export function registerEnterpriseCampaignsView(parent: Command): void {
	parent
		.command('view <enc_id>')
		.description('View one recruitment campaign (with its jobs)')
		.option('--fields <list>', 'output selected fields as JSON (comma-separated dotted paths)')
		.action(async (encId: string, flags: ViewFlags, command: Command) => {
			const ctx = resolveContext(command);
			const globals = command.optsWithGlobals() as { apiKey?: string };
			const { key } = resolveApiKey(globals.apiKey);
			await runEnterpriseCampaignsView(ctx, key, encId, flags);
		});
}
